import Vue, { ComponentOptions } from "vue";
import GhClassService from "@/utils/mixins/clsService";

let com =new Vue( {
    /** 数据 */
    data() {
        return {
            tabs: [
                {
                    title: "物料信息维护",
                    show: true,
                    draw:true,
                },
                {
                    title: "详细信息"
                }
            ],
            argsQuery: {
                keyword: ""
            },
            module: "dynamic_parse_page", // 模块
            cls: "5cac6210d2a0eb1690b334e3", // 类
            serviceMethods: {
                query: null
            },
            templateModel: {}
        };
    },
    /** 方法 */
    methods: {
        /** 导航到该界面时调用 */
        onNavigateTo(params) { },
        /** 查询 */
        query() {
            if (this.$refs.table) {
                this.$refs.table.query();
            }
        },
        /** 初始化行时钩子函数 */
        beforeRowIntial(props) { },
        /** 查询前钩子函数 */
        beforeQuery(args) {
            return args;
        },
        /**保存前钩子函数 */
        beforeSave(item) { },
        /**删除前钩子函数 */
        beforeDelete(item) { }
    },
    watch: {},
    computed: {},
    /** render函数 */
    render(h) {
        let self = this;
        return h("gh-table-page", {
            ref: "table",
            props: {
                argsQuery: this.argsQuery,
                module: this.module,
                cls: this.cls,
                tabs: this.tabs,
                showTabs: true,
                templateModel: this.templateModel,
                beforeRowIntial: this.beforeRowIntial,
                beforeQuery: this.beforeQuery,
                beforeSave: this.beforeSave,
                beforeDelete: this.beforeDelete
            },
            on: {
                /** 查看明细 */
                viewItem(item) { },

                /** 查询结束后 */
                "end-query": () => { },
                /** 保存结束后 */
                "save-after": () => { },
                /** 删除结束后 */
                "delete-after": item => {
                    /** ids */
                    if (Array.isArray(item)) {
                    } else {
                        /**id */
                    }
                }
            },
            scopedSlots: {

                
                /** 查询区域 */
                area_query: props =>
                    h("v-text-field", {
                        props: {
                            counter: true,
                            clearable: true,
                            label: "关键字",
                            value: self.argsQuery.keyword,
                            ["append-icon"]: "mdi-circle-edit-outline"
                        },
                        on: {
                            change(value) {
                                self.argsQuery.keyword = value;
                                self.query();

                            },
                            "click:clear": e => {
                                this.argsQuery.keyword = "";
                                self.query();
                            },
                            "keyup": e => {
                                if (e.keyCode !== 27 || e.target !== e.currentTarget) {
                                    return;
                                }
                                self.argsQuery.keyword = "";
                                self.query();
                            }
                        }
                    }),

                /** 详细区域 */
                area_detail: props => null,

                ["table-cell-Cd"]: props => null,

                ["model-prop-Cd"]: (prop, model) => null,

                /** 操作前区域 */
                area_operation_before: props =>
                    h(
                        "v-btn",
                        {
                            props: {
                                color: "primary"
                            },
                            on: {
                                async click(e) {
                                    //   编写调用代码 直接使用invoke 调用后台方法，方法需在serviceMethods中注册
                                    //   let res = await self.invoke("query");
                                    //   console.log(res);
                                }
                            }
                        },
                        "测试"
                    )
            }
        });
    }
})